//회원가입
// src/pages/COM/COM102M1.jsx
import React, {useEffect, useState} from 'react';

import RadioGroup from "components/Radio/RadioGroup";
import Checkbox from "components/Checkbox/Checkbox";
import SelectBox from "components/SelectBox/SelectBox";

import style from './COM102M1.module.scss'
import Button from "../../components/Button/Button";

const COM102M1 = ({com_Handle_Save}) => {

    //(공통) 모달 창 "저장" 버튼 클릭
    useEffect(() => {
        com_Handle_Save(() => {
            console.log("자식 함수 실행됨!");
        });
    }, [com_Handle_Save]);


    /* 입력 정보*/
    const [hsptCd,setHsptCd] = useState(false); //기관

    const [isIDChkOk,setIsIDChkOk] = useState(false); //ID 확인 여부




    const [selectedOption, setSelectedOption] = useState("N"); //초기화 값
    const handleRadioChange = (value) => {
        setSelectedOption(value);
    };

    return(
        <main className={style.main_wrap}>
            <div className={style.info__text}>
                <h3>필수정보</h3>
                <p>필수정보(아이디,비밀번호,생년월일,휴대폰번호,이메일)을 입력해 주세요.</p>
            </div>
            <div className={style.signup_box}>
                <div className={style.signup_item}>
                    <label>사용자 구분</label>
                    <div style={{height:"23px"}}>
                        <RadioGroup
                            options={[{ value: "Y", label: "연구자" }, { value: "N", label: "연구원" },]}
                            selectedValue={selectedOption}
                            onChange={handleRadioChange}
                        />
                    </div>
                    <div className={style.usr_cont}>
                        <ul>
                            <li><span>연구자 :</span> 병원 사번이 있고 공식적으로 연구를 수행할 수 있는 자격이 있는 연구책임자 (예:교수, 간호사, 전공의 등)</li>
                            <li><span>연구원 :</span> 병원 사번이 있는 연구자의 직접적인 관리,감독 하에 연구를 수행하는 연구원(연구보조원 포함)</li>
                        </ul>
                    </div>
                </div>
                <div className={style.signup_item}>
                    <label>기관</label>
                    <SelectBox
                        options={[
                            {value:"18230", label:"고려대의과대학부속 안암병원"},
                            {value:"18247", label:"고려대의과대학부속 구로병원"},
                            {value:"75280", label:"고려대의과대학부속 안산병원"}
                        ]}
                        valueKey="value" labelKey="label"
                        value={hsptCd}
                        onChange={(val) => setHsptCd(val)}
                        />
                </div>
                <div className={style.signup_item}>
                    <label>EHR ID</label>
                    <input
                        type="text"
                        //defaultValue={lginId}
                        //ref={lginIdInputRef}
                        placeholder={"EHR ID를 입력해 주세요."}
                        maxLength={40}
                        //onChange={(e) => setLginId(e.target.value)}
                        />
                </div>
                <div className={style.signup_item}>
                    <label>부서/진료과</label>
                    <input
                        type="text"
                        //defaultValue={lginId}
                        //ref={lginIdInputRef}
                        placeholder={"아이디를 입력해 주세요."}
                        maxLength={40}
                        //onChange={(e) => setLginId(e.target.value)}
                        />
                </div>
                <div className={style.signup_item}>
                    <label>사용자명</label>
                    <input
                        type="text"
                        //defaultValue={lginId}
                        //ref={lginIdInputRef}
                        placeholder={"사용자명을 입력해 주세요."}
                        maxLength={40}
                        //onChange={(e) => setLginId(e.target.value)}
                        />
                </div>
                <div className={style.signup_item}>
                    <label>사용자 ID</label>
                    <p>6~12자의 영문 소문자, 숫자와 특수기호(_),(-)만 사용 가능합니다.</p>
                    <div className={style.userId_wrap}>
                        <input
                            type="text" name="lginId" minLength={6} maxLength={12}
                            placeholder={"사용자 ID를 입력해 주세요."}
                            //value={getMngr("lginId").value}
                            //ref={(el) => (refs.current["lginId"] = el)} // ref 동적 할당
                            //onChange={(e) => handleChange(e)}
                            //readOnly={isIDChkOk}
                        />
                        {!isIDChkOk &&
                            <Button variant="Outline" size="md" name="chkId" addStyle={{width: "68px", height: "40px"}}
                                //disabled={isIDChkOk ? "disabled" : null } onClick={!isIDChkOk ? handleClick_ChkId : null}
                                >ID확인
                            </Button>
                            }
                    </div>
                </div>
                <div className={style.signup_item}>
                    <label>비밀번호</label>
                    <input
                        type="text"
                        //defaultValue={lginId}
                        //ref={lginIdInputRef}
                        placeholder={"비밀번호를 입력해 주세요."}
                        maxLength={40}
                        //onChange={(e) => setLginId(e.target.value)}
                        />
                </div>
                <div className={style.signup_item}>
                    <label>비밀번호 확인</label>
                    <input
                        type="text"
                        //defaultValue={lginId}
                        //ref={lginIdInputRef}
                        placeholder={"비밀번호를 재입력해 주세요."}
                        maxLength={40}
                        //onChange={(e) => setLginId(e.target.value)}
                        />
                </div>
            </div>
            <hr/>
            <h3>추가정보</h3>
            <div className={style.signup_box_sub}>
                <div className={style.signup_item}>
                    <label>전화번호</label>
                    <input
                        type="text"
                        //defaultValue={lginId}
                        //ref={lginIdInputRef}
                        placeholder={"‘-’를 제외히고 입력해 주세요."}
                        maxLength={40}
                        //onChange={(e) => setLginId(e.target.value)}
                        />
                </div>
                <div className={style.signup_item}>
                    <label>휴대전화</label>
                    <input
                        type="text"
                        //defaultValue={lginId}
                        //ref={lginIdInputRef}
                        placeholder={"‘-’를 제외히고 입력해 주세요."}
                        maxLength={40}
                        //onChange={(e) => setLginId(e.target.value)}
                        />
                </div>
                <div className={style.signup_item}>
                    <label>이메일</label>
                    <input
                        type="text"
                        //defaultValue={lginId}
                        //ref={lginIdInputRef}
                        placeholder={"이메일을 입력해 주세요."}
                        maxLength={40}
                        //onChange={(e) => setLginId(e.target.value)}
                        />
                </div>
            </div>
            <hr/>
            <div className={style.signUp_grp_terms}>
                <div className={style.termsCont}>
                    <p>&lt;HEALTH SCAN MED 이용약관&gt;</p>
                    <pre>{terms}</pre>
                </div>
                <div className={style.termsAgrmt}>
                    <Checkbox
                        id="termAgree"
                        label={"(필수) 서비스 이용약관 동의"}
                        //onChange={e => !isCompleted ? setIsTermAgree(e.target.checked) : null}
                        //checked={isTermAgree}
                        //ref={termAgreeRef}
                    />
                </div>
            </div>
        </main>
    )
}
export default COM102M1;


const terms = `제 1 장 환영합니다!
제 1 조 목적
KUMC CDM 포탈 플랫폼을 이용해주셔서 감사합니다. 본 약관은 여러분이 “KUMC CDM 포탈 플랫폼(이하 CDM 포탈)”을 이용하는 데 필요한 권리, 의무, 책임사항과 기타 필요한 사항을 규정하고 있으므로 조금만 시간을 내서 주의 깊게 읽어주시기 바랍니다.

제 2 조 용어의 정의
1. "이용자"라 함은 CDM 포탈에 접속하여 본 약관에 따라 CDM 포탈이 제공하는 서비스를 이용하는 회원을 말합니다.
2. “서비스”라 함은 CDM 포탈이 제공하는 도서정보, 도서내용, 작업표준을 말합니다.
3. "회원"이라 함은 서비스를 이용하기 위하여 CDM 포탈에 개인정보를 제공하여 아이디(ID)와 비밀번호를 부여 받은 자를 말합니다.
4. “회원 아이디(ID)"라 함은 회원의 식별 및 서비스 이용을 위하여 자신이 선정한 문자 및 숫자의 조합을 말합니다.
5. "비밀번호"라 함은 회원이 자신의 개인정보 및 직접 작성한 비공개 콘텐츠의 보호를 위하여 선정한 문자, 숫자 및 특수문자의 조합을 말합니다.

제 3 조 이용약관의 효력 및 변경
1. 본 약관의 내용은 CDM 포탈의 초기 서비스 화면에 게시하거나 기타의 방법으로 공지하고, 본 약관에 동의한 회원 모두에게 그 효력이 발생합니다.
2. CDM 포탈은 본 약관을 개정할 경우에 적용일자 및 개정사유를 명시하여 현행 약관과 함께 CDM 포탈의 초기화면에 그 적용일자 7일 이전부터 적용일자 전일까지 공지합니다. 다만, 회원에게 불리하게 약관내용을 변경하는 경우에는 최소한 30일 이상의 사전 유예기간을 두고 공지합니다. 이 경우 CDM 포탈은 개정 전 내용과 개정 후 내용을 명확하게 비교하여 이용자가 알기 쉽도록 표시합니다.
3. CDM 포탈이 전항에 따라 개정약관을 공지하면서 “개정일자 적용 이전까지 회원이 명시적으로 거부의 의사표시를 하지 않는 경우 회원이 개정약관에 동의한 것으로 봅니다.”라는 취지를 명확하게 공지하였음에도 회원이 명시적으로 거부의 의사표시를 하지 않은 경우에는 개정약관에 동의한 것으로 봅니다. 회원이 개정약관에 동의하지 않는 경우 CDM 포탈 이용계약을 해지할 수 있습니다.

제 4 조 약관 외 준칙
1. 본 약관은 CDM 포탈이 제공하는 서비스에 관한 이용안내와 함께 적용됩니다.
2. 본 약관에 명시되지 아니한 사항은 관계법령 및 의료원 내부 규정, 그리고 CDM 포탈의 개인정보처리방침 등에 따릅니다.

제 2 장 이용계약의 체결
제 5 조 이용계약의 성립
이용계약은 본 약관에 「동의합니다」를 선택하고, CDM 포탈이 정한 회원가입양식을 작성하여 서비스 이용을 신청한 후, CDM 포탈이 이를 승낙함으로써 성립합니다.

제 6 조 회원가입
서비스를 이용하기 위해서는 CDM 포탈에서 정한 회원가입양식에 개인정보를 기재하여 가입을 하여야 합니다.

제 7 조 개인정보의 보호 및 사용
1. CDM 포탈은 관계법령 및 내부 규정에 따라 회원의 개인정보를 보호하기 위해 노력합니다. 회원 개인정보의 보호 및 사용에 관해서는 관련 법령, 의료원 내부 지침, 그리고 CDM 포탈의 개인정보처리방침이 우선 적용됩니다.
2. CDM 포탈은 의료원 원내 직원(회원)의 연락처(이메일, 전화번호 등)를 다음 각 호의 목적 범위 내에서 조회 및 공개할 수 있습니다.
1. 회원 본인 확인 등 업무
2. 의료원 내부 구성원 간 원활한 커뮤니케이션 및 협업
3. 서비스 운영을 위한 시스템 문의, 알림, 공지 등 전달
3. 위 2항에 따라, CDM 포탈은 원내에서만 사용되는 포털임을 전제로, 해당 정보(연락처)가 다른 직원(회원)들에게 제한적으로 공개될 수 있습니다. 단, CDM 포탈은 공개가 불필요한 경우 또는 회원 요청이 있는 경우, 개인정보처리방침 및 시스템 설정을 통해 공개 범위를 조정하거나 비공개로 전환할 수 있는 방안을 제공합니다.
4. CDM 포탈은 위 제2항 및 제3항에서 정한 목적 범위를 초과하여 개인정보를 활용하거나 제3자에게 제공할 경우, 관계법령에 따라 사전에 회원의 별도 동의를 받습니다.
5. 회원은 공지된 방법에 따라 자신의 연락처 공개 범위를 직접 변경할 수 있으며, 원하지 않는 경우 비공개로 설정할 수 있습니다. 다만, 업무상 필수적인 확인·연락을 위한 최소 정보(예: 이메일 등)는 비공개 설정 시 일부 업무 이용이 제한될 수 있습니다.
6. 의료원 원내에서 직원 간 연락처 조회가 가능하므로, 회원은 타인의 개인정보를 목적 외로 사용하거나, 의료원 외부로 무단 반출(제공)하거나, 스팸 목적 등으로 활용해서는 안 됩니다. 위반 시 관련 법령 및 내부 규정에 따라 이용 제한, 징계 등 불이익을 받을 수 있습니다.

제 8 조 이용 신청의 승낙과 제한
1. CDM 포탈은 제5조의 규정에 의한 이용신청자에 대하여 약관에 정하는 바에 따라 서비스 이용을 승낙합니다.
2. CDM 포탈은 아래 사항에 해당하는 경우에 대해서 회원가입을 승낙하지 아니하거나 이후 사전 통보 없이 취소할 수 있습니다.
1. 회원가입 신청 시 허위 내용을 기재한 경우
2. 타인의 정보를 도용하거나, 본인의 정당한 권한 없이 의료원 시스템을 이용하려고 시도한 경우
3. 기타 본 약관 또는 관계 법령, 내부 규정을 위반한 사실이 확인된 경우

제 9 조 회원 아이디 부여 및 변경 등
1. CDM 포탈은 이용신청자에 대하여 약관에 정하는 바에 따라 자신이 선정한 회원 아이디를 부여합니다.
2. 회원 아이디는 원칙적으로 변경이 불가하며 부득이한 사유로 인하여 변경하고자 하는 경우에는 해당 아이디를 해지하고 재가입해야 합니다.
3. 회원은 회원가입 시 기재한 개인정보가 변경되었을 경우 온라인으로 직접 수정할 수 있습니다. 이때 변경하지 않은 정보로 인해 발생되는 문제에 대한 책임은 회원에게 있습니다.

제 3 장 서비스의 이용
제 10 조 서비스 이용 시간
1. 회원의 이용신청을 승낙한 때부터 서비스를 개시합니다. 단, 일부 서비스의 경우에는 지정된 일자부터 서비스를 개시합니다.
2. 업무상 또는 기술상의 장애로 인하여 서비스를 개시하지 못하는 경우에는 CDM 포탈의 초기 서비스 화면에 게시하거나 기타의 방법으로 통지합니다.
3. 서비스의 이용은 연중무휴, 1일 24시간을 원칙으로 하며, 서비스 응대 및 처리 시간은 법정 근무일 근무시간(09:00~18:00, 법정공휴일 및 주말 제외)으로 합니다. 다만,  KUMC CDM 플랫폼의 업무상 또는 기술상의 이유로 서비스가 일시 중지될 수 있습니다. 이러한 경우 KUMC CDM 플랫폼은 사전 또는 사후에 이를 공지합니다.

제 11 조 서비스의 변경, 중단
1. CDM 포탈은 기술상•운영상의 필요에 의해 제공하는 서비스의 일부 또는 전부를 변경하거나 중단할 수 있습니다. 서비스를 중단하는 경우에는 30일 전에 초기화면에  이를 공지하되, 다만 사전에 통지할 수 없는 부득이한 사정이 있는 경우는 사후에 통지를 할 수 있습니다.
2. 제1항의 경우에 CDM 포탈이 제공하는 서비스의 이용과 관련하여, KUMC CDM 플랫폼은  여러분에게 발생한 어떠한 손해에 대해서도 책임을 지지 않습니다. 다만, CDM 포탈의 고의 또는 중대한 과실로 인하여 발생한 손해의 경우는 제외합니다.

제 4 장 계약 해지 및 이용 제한
제 12 조 계약 해지
1. 회원은 언제든지 이용계약 해지를 신청할 수 있으며, CDM 포탈은 관련 법령 및 내부 규정에 따라 이를 처리합니다.
2. 회원이 계약을 해지할 경우, 관계법령 및 내부 규정상 보관 의무가 있는 경우를 제외하고, 회원의 모든 데이터는 삭제·파기됩니다.

제 13 조 서비스 이용제한
1. CDM 포탈은 회원이 서비스 이용에 있어서 본 약관 및 관련 법령을 위반하거나, 기타 정상적인 서비스 운영에 방해가 될 경우 서비스 이용을 제한할 수 있습니다.
2. 상기 이용제한 규정에 따라 서비스를 이용하는 회원에게 사전 통지 후 서비스 이용을 일시정지 등 제한하거나 이용계약을 해지할 수 있습니다. 단, 불가피한 사유로 사전 통지가 불가능한 경우에는 그러하지 아니합니다.

제 5 장 기타
제 14 조 손해배상
CDM 포탈에서 제공되는 서비스와 관련하여 회원에게 어떠한 손해가 발생하더라도 CDM 포탈이 고의 또는 과실로 인한 손해발생을 제외하고는 이에 대하여 책임을 부담하지 아니합니다.

제 15 조 분쟁의 해결
서비스 이용으로 발생한 분쟁에 대해 소송이 제기되는 경우 민사 소송법상의 관할 법원에 제기합니다.

시행일자 : 2022년 07월 01일
갱신 시행일자 : 2025년 01월 07일
`;